import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Lightweight navigation helper built on top of React Router.
 */
export const useRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    push: (path: string) => navigate(path),
    replace: (path: string) => navigate(path, { replace: true }),
    back: () => navigate(-1),
    pathname: location.pathname,
    query: location.search,
  };
};